import Media from "emun.media/media.model";
import ServiceBusController from "servicestack/service-bus.controller";

export default class MediaSliderController extends ServiceBusController {
  $onInit() {
    console.info("$onInit", this);
    const $ctrl = this;
    if (!$ctrl.slidesToShow) $ctrl.slidesToShow = [1, 2, 3, 5];
    if (!$ctrl.slidesToScroll) $ctrl.slidesToScroll = [1, 2, 3, 5];
    if (!$ctrl.speed) $ctrl.speed = 500;
    if ($ctrl.arrows !== false) $ctrl.arrows = true;
    if ($ctrl.dots !== true) $ctrl.dots = false;
  }

  onMediaLoad(res) {
    const $ctrl = this;
    console.info("onMediaLoad", { res, $ctrl });
    if ($ctrl.exclude) {
      res.data.results = res.data.results.filter((p) => p.id !== this.exclude);
    }
    $ctrl.media = res.data.results.map((m) => new Media(m));
    $ctrl.results = $ctrl.media;
  }

  $onChanges({ mediaIds, search, tagCriteria }) {
    const $ctrl = this;
    //console.info("$onChanges", $ctrl);
    this.$cart.$$load.then(() => {
      if (
        mediaIds &&
        Array.isArray(mediaIds.currentValue) &&
        mediaIds.currentValue.length
      ) {
        this.$cart.bus
          .read(
            "QueryMedia.json?Take=" + ($ctrl.take || 50) + "&MediaSlider=IdIn",
            {
              Realm: $ctrl.realm,
              IdIn: mediaIds.currentValue.join(",") || "$NOTHING!PROVIDED$",
            }
          )
          .then(this.onMediaLoad.bind(this));
      } else if (search && search.currentValue) {
        this.$cart.bus
          .read(
            "QueryMedia.json?Take=" +
              ($ctrl.take || 50) +
              "&MediaSlider=Search",
            {
              Realm: $ctrl.realm,
              Search: search.currentValue,
            }
          )
          .then(this.onMediaLoad.bind(this));
      } else if (
        tagCriteria &&
        tagCriteria.currentValue &&
        Object.keys(tagCriteria.currentValue).length >= 1 &&
        Array.isArray(
          tagCriteria.currentValue[Object.keys(tagCriteria.currentValue)[0]]
        ) &&
        tagCriteria.currentValue[Object.keys(tagCriteria.currentValue)[0]]
          .length > 0
      ) {
        this.$cart.bus
          .send(
            "QueryMedia.json?Take=" +
              ($ctrl.take || 50) +
              "&MediaSlider=TagCriteria",
            {
              Realm: $ctrl.realm,
              tagCriteria: tagCriteria.currentValue,
            }
          )
          .then(this.onMediaLoad.bind(this));
      }
    });
  }
}
